import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import useScrollTop from "../../utils/useScrollTop";
import RegisterForm from "../../components/account/RegisterForm";
import { Helmet } from "react-helmet";
import { errorNotify } from "../../Services/Notification";
const addVisitorAPIURL = `${process.env.REACT_APP_API_URL}api/user/register`;

const Register = () => {
  useScrollTop();
  const currentUrl = window.location.href;
  const emailTimerRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [checkUsername, setCheckUsername] = useState({
    email: "empty",
    phone: "empty",
  });

  const orgSchemeData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "I4invest",
    url: "https://i4invest.in/",
    logo: "https://i4invest.in/images/logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-9769699957",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: "en",
    },
  };

  const [userRegistration, SetUserRegistration] = useState({
    first_name: "",
    email: "",
    password: "",
    last_name: "",
    mobile: "",
    password2: "",
  });

  const [registerError, setRegisterError] = useState("");
  const [registerVisible, setRegisterVisible] = useState(false);
  const [confirmregisterVisible, setConfirmRegisterVisible] = useState(false);
  const [lastValidatedMobile, setLastValidatedMobile] = useState("");
  const [lastValidatedEmail, setLastValidatedEmail] = useState("");
  const [isButtonClicked, setIsButtonClicked] = useState();
  // Validation

  const [errorsData, setErrorsData] = useState({
    first_name: [],
    last_name: [],
    mobile: [],
    email: [],
    password: [],
    password2: [],
  });

  const validateForm = () => {
    let formErrors = {
      first_name: [],
      last_name: [],
      mobile: [],
      email: [],
      password: [],
      password2: [],
    };
    let isValid = true;

    // First Name validation
    if (!userRegistration.first_name.trim()) {
      formErrors.first_name = "Please enter first name";
      isValid = false;
    }
    // Last Name validation
    if (!userRegistration.last_name.trim()) {
      formErrors.last_name = "Please enter last name";
      isValid = false;
    }

    // Mobile Number validation
    if (!userRegistration.mobile) {
      formErrors.mobile = "Please enter a valid mobile number";
      isValid = false;
    } else if (!isValidPhoneNumber(userRegistration.mobile)) {
      formErrors.mobile = "Invalid Phone Number";
      isValid = false;
    }

    // Email validation
    if (!userRegistration.email.trim()) {
      formErrors.email = "Please enter a valid email address";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(userRegistration.email)) {
      formErrors.email = "Invalid email address";
      isValid = false;
    }

    // Password validation
    let passwordErrors = [];
    if (!userRegistration.password) {
      passwordErrors.push("Please Enter a password");
      formErrors.password = passwordErrors;
      isValid = false;
    }
    if (userRegistration.password && userRegistration.password.length < 8) {
      passwordErrors.push("Must be atleast 8 characters long");
      formErrors.password = passwordErrors;
      isValid = false;
    }
    if (
      userRegistration.password &&
      !validatePassword(userRegistration.password)
    ) {
      passwordErrors.push("Atleast one digit (0-9) & special character (#&@%)");
      formErrors.password = passwordErrors;
      isValid = false;
    }
    if (
      userRegistration.password &&
      !isValidPassword(userRegistration.password)
    ) {
      passwordErrors.push("Use atleast one Upper Case letter");
      formErrors.password = passwordErrors;
      isValid = false;
    }

    // Confirm password validation
    if (!userRegistration.password2) {
      formErrors.password2 = "";
      isValid = false;
    } else if (userRegistration.password2 !== userRegistration.password) {
      formErrors.password2 = "Passwords do not match";
      isValid = false;
    }

    setErrorsData(formErrors);
    return isValid;
  };

  const isValidPassword = (password) => {
    const passCase = /^(?=.*[A-Z])(?=.*\d)/;
    return passCase.test(password);
  };

  const validatePassword = (password) => {
    const specialChars = /[@#$%]/;
    const numbers = /[0-9]/;
    return specialChars.test(password) && numbers.test(password);
  };

  const handlePasswordValidate = (e) => {
    const name = e?.target?.name;
    const value = e?.target?.value;

    let formErrors = {
      password: [],
      password2: [],
    };
    let isValid = true;
    let passwordErrors = [];
    if (name === "password") {
      if (value && value.length < 8) {
        passwordErrors.push("Must be at least 8 characters long");
        isValid = false;
      }
      if (value && !validatePassword(value)) {
        passwordErrors.push(
          "Must include at least one digit (0-9) and one special character (@, #, $, %)",
        );
        isValid = false;
      }
      if (value && !isValidPassword(value)) {
        passwordErrors.push("Must contain exactly one uppercase letter");
        isValid = false;
      }
    }
    if (name === "password2") {
      if (!value) {
        formErrors.password2 = "";
        isValid = false;
      } else if (value !== userRegistration.password) {
        formErrors.password2 = "Passwords do not match";
        isValid = false;
      }
    }

    formErrors.password = passwordErrors;
    setErrorsData(formErrors);
    return isValid;
  };

  const isValidPhoneNumber = (mobile) => {
    return /^\d{10}$/.test(mobile);
  };

  useEffect(() => {
    if (userRegistration?.email) {
      checkEmail("api/check-email");
    }
  }, [userRegistration?.email]);

  useEffect(() => {
    if (userRegistration?.mobile) {
      checkPhone("api/check-phone");
    }
  }, [userRegistration?.mobile]);

  const checkEmail = async (url) => {
    if (emailTimerRef.current) {
      clearTimeout(emailTimerRef.current);
    }

    emailTimerRef.current = setTimeout(async () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(userRegistration.email)) {
        if (
          lastValidatedEmail &&
          lastValidatedEmail !== "" &&
          userRegistration.email !== lastValidatedEmail
        ) {
          try {
            const response = await axios.post(
              process.env.REACT_APP_API_URL + url,
              { email: userRegistration.email },
            );
            if (response.status === 200) {
              setCheckUsername((prev) => ({
                ...prev,
                email: response.data.data.exists,
              }));
              setLastValidatedEmail(userRegistration.mobile);
            }
          } catch (error) {
            console.log(error);
          }
        } else if (!lastValidatedEmail || lastValidatedEmail === "") {
          try {
            const response = await axios.post(
              process.env.REACT_APP_API_URL + url,
              { email: userRegistration.email },
            );
            if (response.status === 200) {
              setCheckUsername((prev) => ({
                ...prev,
                email: response.data.data.exists,
              }));

              setLastValidatedEmail(userRegistration.mobile);
            }
          } catch (error) {
            console.log(error);
          }
        }
      }
      // else {
      //   setCheckUsername((prev) => ({
      //     ...prev,
      //     email: true,
      //   }));
      // }
    }, 100);
  };

  const checkPhone = async (url) => {
    if (userRegistration?.mobile?.length === 10) {
      if (
        lastValidatedMobile &&
        lastValidatedMobile !== "" &&
        userRegistration.mobile !== lastValidatedMobile
      ) {
        try {
          const response = await axios.post(
            process.env.REACT_APP_API_URL + url,
            {
              mobile: userRegistration.mobile,
            },
          );

          if (response.status === 200) {
            setCheckUsername((prev) => ({
              ...prev,
              phone: response.data.data.exists,
            }));
            setLastValidatedMobile(userRegistration.mobile);
          }
        } catch (error) {
          console.error(error);
        }
      } else if (!lastValidatedMobile || lastValidatedMobile === "") {
        try {
          const response = await axios.post(
            process.env.REACT_APP_API_URL + url,
            {
              mobile: userRegistration.mobile,
            },
          );

          if (response.status === 200) {
            setCheckUsername((prev) => ({
              ...prev,
              phone: response.data.data.exists,
            }));
            setLastValidatedMobile(userRegistration.mobile);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
    //  else {
    //   setCheckUsername((prev) => ({
    //     ...prev,
    //     phone: true,
    //   }));
    // }
  };

  const registerInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const filteredValue =
      name === "first_name" || name === "last_name"
        ? value.replace(/[^a-zA-Z\s]/g, "")
        : value;

    SetUserRegistration({ ...userRegistration, [name]: filteredValue });
    handlePasswordValidate();
    setRegisterError("");
  };

  const registerForm = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsButtonClicked(true);
      try {
        const payload = {
          ...userRegistration,
          visitor: true,
        };

        const res = await axios.post(addVisitorAPIURL, payload);
        if (!res.data.error) {
          setIsButtonClicked(false);
          dispatch({
            type: "setUserData",
            payload: {
              username: " ",
              first_name: userRegistration.first_name,
              email: userRegistration.email,
              password: userRegistration.password,
              last_name: userRegistration.last_name,
              mobile: userRegistration.mobile,
              password2: userRegistration.password2,
              role_name: "Admin",
            },
          });

          navigate("/UzAJ/y4fN/kdSuVuxGEcEw==");
        } else {
          errorNotify(res.data.message);
          setIsButtonClicked(false);
        }

        setIsButtonClicked(false);
      } catch (error) {
        errorNotify(error.response.data.message);
        setIsButtonClicked(false);
      }
    }
  };

  return (
    <div>
      {/* Register Now */}
      <Helmet>
        <link rel="canonical" href={currentUrl} />
        <title>Register | I4Invest</title>
        <meta
          name="description"
          content="Sign up with I4Invest to access India’s leading portfolio management software and mutual fund tracker. Start managing your investments effortlessly today!"
        />
        <meta
          property="og:image"
          content="https://i4invest.in/logo_i4invest-01.png"
        />
        <meta name="robots" content="index, follow" />
        <script type="application/ld+json">
          {JSON.stringify(orgSchemeData)}
        </script>
      </Helmet>
      <div className="w-full bg-[#ffffff] px-4 pb-[80px] pt-[130px]">
        <div className="mx-auto max-w-[1400px] px-[16px] md:px-0">
          <div className="flex items-center justify-start gap-[25px] md:gap-[45px]">
            <img
              className="w-full max-w-[40px]"
              src="images/Back-Arrow-btn.png"
              alt=""
              onClick={() => {
                navigate("/");
              }}
            />
            <h2 className="font-open text-[30px] font-[400] leading-[40px] text-[#1E1E1E] md:text-[40px] md:leading-[60px]">
              Register Now
            </h2>
          </div>
        </div>

        <div className="mx-auto max-w-[1235px] px-[16px] md:px-0">
          <div className="flex flex-wrap items-start justify-between md:flex-nowrap">
            <div>
              <h2 className="pb-[10px] font-open text-[24px] font-[700] leading-[36px] text-[#1E1E1E]">
                Create A Profile
              </h2>
              <p className="pb-[40px] font-open text-[16px] font-[400] leading-[24px] text-[#B6B6B6]">
                Required fields have an asterisk*
              </p>

              <div>
                <RegisterForm
                  registerError={registerError}
                  registerForm={registerForm}
                  userRegistration={userRegistration}
                  registerInput={registerInput}
                  errorsData={errorsData}
                  checkEmail={checkEmail}
                  checkPhone={checkPhone}
                  checkUsername={checkUsername}
                  registerVisible={registerVisible}
                  setRegisterVisible={setRegisterVisible}
                  confirmregisterVisible={confirmregisterVisible}
                  setConfirmRegisterVisible={setConfirmRegisterVisible}
                  handlePasswordValidate={handlePasswordValidate}
                  isButtonClicked={isButtonClicked}
                />
              </div>
            </div>

            <div className="pt-[40px] md:pt-0">
              <h2 className="text-center font-open text-[30px] font-[700] uppercase leading-[40px] text-[#231C42] md:text-[40px] md:leading-[60px]">
                Invest
                <span className="inline-block md:block">With Confidence</span>
              </h2>
              <p className="mx-auto w-full pb-[24px] pt-[10px] text-center font-open text-[14px] font-[600] leading-[24px] text-[#B6B6B6] md:w-[347px]">
                Unlock Your Investment Potential with Precision Portfolio
                Management
              </p>
              <div>
                <img
                  className="w-full"
                  src="images/Financial-growth.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;